import { render, staticRenderFns } from "./KpiAverageWaitingTime.vue?vue&type=template&id=722f8e7d&"
import script from "./KpiAverageWaitingTime.vue?vue&type=script&lang=js&"
export * from "./KpiAverageWaitingTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports